export const serviceObj = {
    lightBg: false,
    lightTextDesc: true,
    topLine: 'EASY SET UP',
    headline: 'Super fast and simple process',
    description: 'Get everything set up and ready in under 10 minutes. All you need to do is to add your information and you are ready to go',
    buttonLabel: 'Get Started',
    imgStart: '',
    img: './pictures/ServiceIcons/Icon1.svg',
    alt: 'imagess'
}

export const serviceObjOne = {
    lightBg: false,
    lightTextDesc: true,
    topLine: 'TRANSACTION',
    headline: 'Every transaction is secured',
    description: 'We provide the finest services at the most reasonable prices for your desired service, which is handled swiftly and conveniently.',
    buttonLabel: 'Get Started',
    imgStart: 'start',
    img: './pictures/ServiceIcons/Icon2.svg',
    alt: 'imagess'
}

export const serviceObjThree = {
    lightBg: false,
    lightTextDesc: true,
    topLine: 'DESIGN',
    headline: 'Personalized website design',
    description: "Providing a user-friendly design that appeals to the client's interests and preferences in order to boost their business solution",
    buttonLabel: 'Get Started',
    imgStart: '',
    img: './pictures/ServiceIcons/Icon3.svg',
    alt: 'imagess'
}